import type { ReactNode } from "react";
import type { AriaButtonOptions } from "react-aria";

import { cssFns } from "../css";
import {
  DesktopArrowDown,
  DesktopArrowUp,
  LineCloseCircle,
  LineCloseIcon,
} from "../icons";
import { colors } from "../theme";

export const ButtonIcon = ({
  icon,
  onPress,
}: {
  icon: ReactNode;
  onPress?: () => void;
}) => {
  return (
    <div
      css={[cssFns.center, { zIndex: 10 }]}
      onPointerDown={(e) => {
        if (onPress) {
          e.stopPropagation();
          onPress();
        }
      }}
    >
      {icon}
    </div>
  );
};

export const ClearIcon = ({
  onPress,
  variant = "circled",
}: {
  onPress?: () => void;
  variant: "transparent" | "circled";
}) => {
  return (
    <ButtonIcon
      icon={
        variant === "circled" ? (
          <LineCloseCircle color={colors.principal.gs8} />
        ) : (
          <LineCloseIcon
            color={colors.principal.white}
            width={20}
            height={20}
          />
        )
      }
      onPress={onPress}
    />
  );
};

export const DropdownIcon = ({
  state,
  triggerProps,
  onPress,
}: {
  state?: boolean;
  triggerProps?: AriaButtonOptions<"button">;
  onPress?: () => void;
}) => {
  const icon =
    typeof state !== "undefined" ? (
      state ? (
        <DesktopArrowUp />
      ) : (
        <DesktopArrowDown />
      )
    ) : triggerProps?.["aria-expanded"] ? (
      <DesktopArrowUp />
    ) : (
      <DesktopArrowDown />
    );

  return <ButtonIcon icon={icon} onPress={onPress} />;
};
